module.exports = __webpack_public_path__ + "static/media/redux.2e59cf38.svg";